import { Component, OnInit } from '@angular/core';
import { Message } from 'src/app/models/message';
import { Foros } from 'src/app/models/obs/foros';
import { AccessService } from 'src/app/services/access.service';
import { ForosService } from 'src/app/services/obs/foros.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';

@Component({
  selector: 'app-admforums-list',
  templateUrl: './admforums-list.component.html',
  styleUrl: './admforums-list.component.scss'
})
export class AdmforumsListComponent implements OnInit {

  foros: Foros[] = null;
  msg: Message;
  idForo: number = 25;//

  filteredData: any[] = [];
  searchTerm: string = '';

  filters = {
    searchText: '',
    estado: null as boolean | null
  };

  constructor(
    private foroS: ForosService,
    private accesService: AccessService,
    private ts: TokenStorageService
  ) { }

  ngOnInit() {
    this.getAllForums();
    this.getPermission();
  }

  //bandera que controla la creacion de contenido
  accessMP: boolean = false
  //bandera que controla la edicion de contenido
  accessME: boolean = false
  //bandera que controla la eliminacion de contenido
  accessMD: boolean = false
  //bandera que controla la creacion de texto introductorio de la seccion
  createText: boolean = false;
  /* Permite determinar si el usuario actual tiene permiso para el modulo */
  inf = {}
  getPermission() {
    this.inf['userId'] = this.ts.getUser().id;
    this.inf['accessId'] = 18; //modulo publicaciones
    const data = this.inf;
    this.accesService.getPermissionUser(data).subscribe({
      next: res => {
        this.accessMP = res['result'].create;
        this.accessME = res['result'].edit;
        this.accessMD = res['result'].del;
        this.createText = res['result'].createText;
      },
      error: err => {
        this.msg = err;
      }
    });
  }

  /*Listamos todas las foros*/
  getAllForums() {
    this.foros = null;
    this.foroS.getAll4Admin().subscribe({
      next: res => {
        this.foros = res['data'];
        this.filteredData = [...this.foros];
        this.applyFilter(); 
      },
      error: err => {
        this.msg = err;
      }
    });
  }

    // Método de filtro
  applyFilter(): void {
    this.filteredData = this.foros.filter(obj =>
      // Filtro compartido para nombreLargo y codigo
      (this.filters.searchText 
        ? obj.title.toLowerCase().includes(this.filters.searchText.toLowerCase()) || 
          obj.episode.toLowerCase().includes(this.filters.searchText.toLowerCase()) 
        : true) &&
      // Filtro select para estado
      (this.filters.estado !== null ? obj.status === this.filters.estado : true)
    );
  } 

  delForum(id: number) {
    if (confirm("¿Estás seguro de que deseas eliminar este registro?")) {
      this.foroS.delete(id).subscribe({
        next: res => {
          this.foros = this.foros.filter(network => network.id !== id);
          const popup = document.getElementById('popup');
          const message = document.getElementById('message');
          message.innerText = 'Se eliminó el registro';
          popup.style.display = 'block';
          setTimeout(() => {
            popup.style.display = 'none';
          }, 3000);
          this.getAllForums();
        },
        error: err => {
          console.error("No se pudo eliminar el registro")
        }
      });
    }
  }

}


